import React from 'react';
import withSEO from 'Hoc/withSEO';
import Page5XXV3 from './5XXV3';

const Page502V3: React.FC = () => (
  <Page5XXV3
    title="Bad Gateway"
    text="Failed to connect to the underlying origin server. Please try again in a few seconds."
  />
);

export default withSEO({ title: 'Bad Gateway' })(Page502V3);
